import { flexRender } from "@tanstack/react-table";

const border = "1px solid #bdc9c2";

const tr_styles = {
  background: "var(--superlight)",
};

const th_styles = {
  fontSize: 13,
  borderLeft: border,
  borderRight: border,
};

const AppTableFooters = ({ table, error }) => {
  if (error) return null;

  return (
    <tfoot>
      {table.getFooterGroups().map((footerGroup) => (
        <tr key={footerGroup.id} style={tr_styles}>
          {footerGroup.headers.map((header) => (
            <th key={header.id} style={th_styles} className="px-3">
              {header.isPlaceholder
                ? null
                : flexRender(
                    header.column.columnDef.footer,
                    header.getContext()
                  )}
            </th>
          ))}
        </tr>
      ))}
    </tfoot>
  );
};

export default AppTableFooters;
